import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scorllTop:0,
    isLogin:()=>{
      if(localStorage.getItem('token')||sessionStorage.getItem('token')){
        return true
      }
     return false
    },uid:null
  },
  getters: {
  },
  mutations: {
    setScorllTop(state,it){
      state.scorllTop=it
    },
    setUid(state,it){
      state.uid=it
    }
    
  },
  actions: {
  },
  modules: {
  }
})
